<div *ngIf="loading" class="row">
    <div class="col-lg-6 col-md-12">
        <div class="loading-div-tiny" id="fp-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
            <div class="loading-spinner">
                <div alt="Loading..." class="large progress" aria-label="Loading...">
                    <div class="prog1">
                        <div class="prog2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loyalty-for-u-username section">
    <div class="loyalty-for-u-username mt-0 mb-2" data-default-welcome-text="Welcome">
        <div class="row no-gutters user-name-mod">
            <div class="col-4 col-sm-6 col-md-6">
                <span class="loyalty-user-name"></span>
                <h1 class="loyalty-user-name-heading sr-only" attr.aria-live="polite" attr.aria-label="Rewards Page" attr.aria-level="1" tabindex="-1"> </h1>
            </div>
            <div class="col-8 col-md-6">
                <div class="loyalty-birthday-rewards-mod-unit">
                    <div *ngIf="showNameBirthMod && showPointsScoreCard">
                        <loyalty-birthday-rewards [currentEnvironment]="currentEnvironment" [banner]="banner"
                                                  [userInfo]="userInfo" [userProfile]="userProfile"
                                                  [appHostURL]="appHostURL"></loyalty-birthday-rewards>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="showPointsScoreCard && renderGalleryComponent && isUserAuthenticated">
    <app-points-score-card [currentEnvironment]="currentEnvironment" [banner]="banner" [userInfo]="userInfo"
                           [appHostURL]="appHostURL" [cashRewardsFlow]="cashRewardsFlow" [pointScoreCardFlow]="showPointsScoreCard"></app-points-score-card>
</ng-container>
